$(document).ready(function() {
  $('.slider_Testimonial').slick({
  infinite: true,
  slidesToShow: 1,
  slidesToScroll: 1,
  dots: false,
  arrows: true,
  adaptiveHeight: true,
  nextArrow: '<svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-chevron-right"><polyline points="9 18 15 12 9 6"/></svg>',
  prevArrow: '<svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-chevron-left"><polyline points="15 18 9 12 15 6"/></svg>',
  responsive: [
    {
      breakpoint: 1200,
      settings: {
         dots: true,
         arrows: false
      }
    },
    {
      breakpoint: 600,
      settings: {
         dots: true,
         arrows: false
      }
    },
    {
      breakpoint: 480,
      settings: {
          dots: true,
           arrows: false
      }
    }
    
  ]
});
$('.product_slider').slick({
  slidesToShow: 1,
  slidesToScroll: 1,
  dots: false,
  arrows: true,
  infinite: false,
  adaptiveHeight: true,
   nextArrow: '<svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-chevron-right"><polyline points="9 18 15 12 9 6"/></svg>',
  prevArrow: '<svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-chevron-left"><polyline points="15 18 9 12 15 6"/></svg>',
  responsive: [
    {
      breakpoint: 766,
      settings: {
           arrows: true,
      }
    }
    
  ]
});  
$('.slick_slider_banner').slick({
  slidesToShow: 1,
  slidesToScroll: 1,
  dots: false,
  arrows: true,
  infinite: true,
  adaptiveHeight: true,
   nextArrow: '<svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-chevron-right"><polyline points="9 18 15 12 9 6"/></svg>',
  prevArrow: '<svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-chevron-left"><polyline points="15 18 9 12 15 6"/></svg>',
  responsive: [
    {
      breakpoint: 766,
      settings: {
           arrows: true,
      }
    }
    
  ]
}); 
// $(".custom_accordion > a").on("click", function() {
//     if ($(this).hasClass("active")) {
//       $(this).removeClass("active");
//       $(this).siblings(".content_description").slideUp(200);
//       $(".custom_accordion > a i").removeClass("fa-minus").addClass("fa-plus");
//     } else {
//       $(".custom_accordion > a i").removeClass("fa-minus").addClass("fa-plus");
//       $(this).find("i").removeClass("fa-plus").addClass("fa-minus");
//       $(".custom_accordion > a").removeClass("active");
//       $(this).addClass("active");
//       $(".content_description").slideUp(200);
//       $(this).siblings(".content_description").slideDown(200);
//     }
// });
   
$(".show_button").click(function() {
    $(".box_popup").fadeIn(500);
     $(".header-wrapper").css("z-index", "0");
    $("body").addClass("itg_overflow");
});
$(".custom_close").click(function() {
      $(".box_popup").fadeOut(500);
      $(".header-wrapper").css("z-index", "1");
      $("body").removeClass("itg_overflow");
}); 


// popup pdf 2
$(".show_button_pdf2").click(function() {
    $(".box_popup_pdf_2").fadeIn(500);
     $(".header-wrapper").css("z-index", "0");
    $("body").addClass("itg_overflow");
});
$(".custom_close").click(function() {
      $(".box_popup_pdf_2").fadeOut(500);
      $(".header-wrapper").css("z-index", "1");
      $("body").removeClass("itg_overflow");
}); 

// popup pdf 4
$(".show_button_pdf4").click(function() {
    $(".box_popup_pdf_4").fadeIn(500);
    $(".header-wrapper").css("z-index", "0");
    $("body").addClass("itg_overflow");
});
$(".custom_close").click(function() {
    $(".box_popup_pdf_4").fadeOut(500);
    $(".header-wrapper").css("z-index", "1");
    $("body").removeClass("itg_overflow");
});
// popup pdf 3
$(".show_button_pdf3").click(function() {
    $(".box_popup_pdf_3").fadeIn(500);
     $(".header-wrapper").css("z-index", "0");
    $("body").addClass("itg_overflow");
});
$(".custom_close").click(function() {
      $(".box_popup_pdf_3").fadeOut(500);
      $(".header-wrapper").css("z-index", "1");
      $("body").removeClass("itg_overflow");
}); 
  
$(".custom_header_massg a").click(function() {
    $(".Newsletterpopup").fadeIn(500);
     $("body").addClass("itg_overflow");
});
$(".Newsletter_popup_close").click(function() {
      $(".Newsletterpopup").fadeOut(500);
      $("body").removeClass("itg_overflow");
}); 
$("body.itg_overflow").click(function() {
      $(".Newsletterpopup").fadeOut(500);
}); 
  
 $(".file_download").click (function () {
    var imagePath = $(this).attr('data-attr');
    //  var  imagePath = 'https://cdn.shopify.com/s/files/1/0647/8410/5716/files/cookbook-cover-TMD-3-850x1024_1.png';
    var fileName = "PDF";
    saveAs(imagePath, fileName);
  });

 $(document).on("click",".readmore",function(event) {
    event.preventDefault();
    $(this).closest('.content_description').find(".product-description-full").css("display","block");
    $(this).closest('.content_description').find(".product-description-short").css("display","none");
    //$('.testimonials_image_text').slick('refresh');
    //$(document).find(".testimonials_image_text .slick-slide.slick-current.slick-active").click();
  });
  $(document).on("click",".readless",function(event) {
    event.preventDefault();
    $(this).closest('.content_description').find(".product-description-full").css("display","none");
    $(this).closest('.content_description').find(".product-description-short").css("display","block");
    $('.testimonials_image_text').slick('refresh');
    //$(document).find(".testimonials_image_text .slick-slide.slick-current.slick-active").click();
  }); 

  
});